import { render, staticRenderFns } from "./otherPay.vue?vue&type=template&id=24f6f249&scoped=true&"
import script from "./otherPay.vue?vue&type=script&lang=js&"
export * from "./otherPay.vue?vue&type=script&lang=js&"
import style0 from "./otherPay.vue?vue&type=style&index=0&id=24f6f249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6f249",
  null
  
)

export default component.exports